export default __webpack_public_path__ + "static/media/xml.cc57968e.svg";